import { v4 as idGenerator } from "uuid";
import { difference } from "./objects";

export const equals = (a, b) => a.length === b.length && a.every((v, i) => v === b[i]);

export const equalsUsingDifferences = (a, b) =>
  a?.length === b?.length && a.every((v, i) => Object.keys(difference(a[i], b[i])).length === 0);

export const notNull = (a) => a;

export function toKeyValue(previous, current) {
  return { ...previous, [current[0]]: current[1] };
}

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

export const onlyUniqueByKeyValue = (key) => (value, index, self) => {
  return self.findIndex((i) => i[key] === value[key]) === index;
};

export const identify = (items) => {
  return items.map((item) => ({ ...item, id: idGenerator() }));
};

const _processGlobal = {};
export const processAsync = (items, fn, maxTimePerChunk, context) => {
  const _this = context || _processGlobal;
  let index = 0;
  const now = () => new Date().getTime();
  const data = [];

  return new Promise((resolve) => {
    const doChunk = () => {
      const chunkStartTime = now();

      while (index < items.length && now() - chunkStartTime <= maxTimePerChunk) {
        data.push(fn.call(_this, items[index], index, items));
        ++index;
      }

      if (index < items.length) {
        requestAnimationFrame(doChunk);
      } else {
        resolve(data);
      }
    };
    doChunk();
  });
};
